import React, { useState, useEffect } from 'react';
import Navigation from '../components/Navigation';
import Hero from '../components/Hero';
import Intro from '../components/Intro';
import Storytelling from '../components/Storytelling';
import Experience from '../components/Experience';
import Recognition from '../components/Recognition';
import Contact from '../components/Contact';
import Footer from '../components/Footer';
import SoundControl from '../components/SoundControl';

export default function LandingPage() {
  const [activeSection, setActiveSection] = useState('hero');

  // Accurate scroll tracking for active navigation anchor
  useEffect(() => {
    const sectionIds = ['hero', 'intro', 'story', 'experience', 'recognition', 'contact'];

    const handleScroll = () => {
      const viewportHeight = window.innerHeight;
      // Target line: ~30% from the top of viewport (past fixed header)
      const targetY = Math.min(260, viewportHeight * 0.3);

      let currentSection = 'hero';

      for (const id of sectionIds) {
        const el = document.getElementById(id);
        if (el) {
          const rect = el.getBoundingClientRect();
          if (rect.top <= targetY && rect.bottom > targetY) {
            currentSection = id;
            break;
          }
        }
      }

      setActiveSection(currentSection);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const scrollToAnchor = (id) => {
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="min-h-screen w-full bg-[#F6F2EB] text-[#37332F] flex flex-col selection:bg-[#DED7CC] selection:text-[#37332F] paper-grain relative">
      {/* Navigation with active state and sound toggle */}
      <Navigation activeSection={activeSection} />

      {/* Main Continuous Single-Page Flow */}
      <main className="flex-1">
        {/* 1. Hero */}
        <Hero onScrollDown={scrollToAnchor} />

        {/* 2. Short Intro */}
        <Intro />

        {/* 3. Storytelling & Process */}
        <Storytelling />

        {/* 4. The Experience (CMS Gallery & Lightbox) */}
        <Experience />

        {/* 5. Awards & Recognition */}
        <Recognition />

        {/* 6. Contact Form & Details */}
        <Contact />
      </main>

      {/* 7. Footer */}
      <Footer />

      {/* Floating Sound FX Controller (shows when scrolling down past hero) */}
      <SoundControl />
    </div>
  );
}
